'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default =

function ($sce) {
  "ngInject";
  return {
    restrict: 'A',
    link: function link(scope, element, attributes) {
      scope.$watch(attributes.ngBindHtml, function () {
        element.dotdotdot({ watch: true });
      });
    }
  };
};


// WEBPACK FOOTER //
// ./app/base/directives/bzDot.js